import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';
import { AppRoutes } from '../../App/routes';

export const systemOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}/home`;
export const systemBase = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}`;
export const systemDetailRoute = `${systemBase}/detail`;
export const systemSettingsRoute = `${systemBase}/settings`;
